import { DealRolePermissions, DealRoleType } from "@/src/graphql/generated";
import { classNames } from "@/src/utils/cn";
import { getPermissionSections } from "./dealPermissionConfig";

export function DealPermissionsSummary(props: {
  permissions: DealRolePermissions;
  roleType: DealRoleType;
  className?: string;
}) {
  const sections = getPermissionSections(props.roleType);

  const parts = sections.flatMap((section) => {
    const value = props.permissions[section.key];
    const option = section.options.find((o) => o.value === value);
    if (!option) {
      return [];
    }
    // The first option in every section is the "No Access" variant. Hide it in
    // the summary to keep this top-level view uncluttered.
    if (option.value === section.options[0].value) {
      return [];
    }
    return [{ label: section.label, icon: section.icon, value: option.label }];
  });

  return (
    <div
      className={classNames(
        "flex flex-wrap items-center gap-1.5",
        props.className ?? "",
      )}
    >
      {parts.map((part) => (
        <span
          key={part.label}
          title={part.label}
          className="inline-flex shrink-0 items-center gap-x-1 px-1.5 py-px rounded-md text-xs font-medium whitespace-nowrap bg-transparent text-concrete-700 border border-concrete-200"
        >
          <span className="flex items-center justify-center text-concrete-400 [&>svg]:w-3.5 [&>svg]:h-3.5">
            {part.icon}
          </span>
          <span>{part.value}</span>
        </span>
      ))}
    </div>
  );
}
